import { render } from "./ApprovalView.vue?vue&type=template&id=0f15d476&scoped=true"
import script from "./ApprovalView.vue?vue&type=script&lang=js"
export * from "./ApprovalView.vue?vue&type=script&lang=js"

import "./ApprovalView.vue?vue&type=style&index=0&id=0f15d476&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f15d476"]])

export default __exports__